import HelpCenterLayout from "@components/helpCenter/HelpCenterLayout"
import { ResultView, StoreLink } from "@components/helpCenter/ResultParts"
import { useTranslation } from "react-i18next"

export default function CancelationGooglePage() {
  const { t } = useTranslation()

  return (
    <HelpCenterLayout>
      <ResultView
        icon="warning"
        title={t("pages.helpCenter.activeGoogleSubscription")}
      >
        <p>
          {t("pages.helpCenter.cancelationGoogle.followGoogleInstructions")}
        </p>

        <StoreLink url="https://support.google.com/googleplay/answer/7018481" />
      </ResultView>
    </HelpCenterLayout>
  )
}
